"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverableSearchResultItem = void 0;
var DeliverableSearchResultItem;
(function (DeliverableSearchResultItem) {
    let deploymentState;
    (function (deploymentState) {
        deploymentState["PENDING"] = "pending";
        deploymentState["OUTREACHING"] = "outreaching";
        deploymentState["OUTREACHED"] = "outreached";
        deploymentState["VIEWED"] = "viewed";
        deploymentState["ACCEPTED"] = "accepted";
        deploymentState["RUNNING"] = "running";
        deploymentState["ADJUSTMENT_APPROVAL"] = "adjustment_approval";
        deploymentState["PAYMENT_PROCESSING"] = "payment_processing";
        deploymentState["OUTREACH_TIMEOUT"] = "outreach_timeout";
        deploymentState["OUTREACH_REJECTED"] = "outreach_rejected";
        deploymentState["CANCELED"] = "canceled";
        deploymentState["FAILED_TO_MEET_GOALS"] = "failed_to_meet_goals";
        deploymentState["COMPLETED"] = "completed";
        deploymentState["ABUSE_IDENTIFIED"] = "abuse_identified";
    })(deploymentState = DeliverableSearchResultItem.deploymentState || (DeliverableSearchResultItem.deploymentState = {}));
    let deploymentStatus;
    (function (deploymentStatus) {
        deploymentStatus["DRAFT"] = "draft";
        deploymentStatus["ACTIVE"] = "active";
        deploymentStatus["COMPLETED"] = "completed";
    })(deploymentStatus = DeliverableSearchResultItem.deploymentStatus || (DeliverableSearchResultItem.deploymentStatus = {}));
    let type;
    (function (type) {
        type["BOT_COMMAND"] = "botCommand";
        type["BRIEF"] = "brief";
        type["CONTRACT"] = "contract";
        type["CREATOR_PAY_PER_EVENT"] = "creatorPayPerEvent";
        type["LIVE_STREAM"] = "liveStream";
        type["OVERLAY"] = "overlay";
        type["PANEL_BANNER"] = "panelBanner";
        type["PAY_PER_EVENT"] = "payPerEvent";
        type["PAY_PER_EVENT_BRACKET"] = "payPerEventBracket";
        type["CUSTOM"] = "custom";
        type["DYNAMIC_DESCRIPTION_WIDGET"] = "dynamicDescriptionWidget";
        type["TIK_TOK_CREATIVE"] = "tikTokCreative";
        type["YOU_TUBE_VIDEO"] = "youTubeVideo";
        type["MARKDOWN_BRIEF"] = "markdownBrief";
    })(type = DeliverableSearchResultItem.type || (DeliverableSearchResultItem.type = {}));
    let status;
    (function (status) {
        status["INCOMPLETE"] = "incomplete";
        status["BLOCKED"] = "blocked";
        status["READY"] = "ready";
        status["UNDER_NEGOTIATION"] = "underNegotiation";
        status["GOAL_COMPLETE"] = "goalComplete";
        status["GOAL_IN_PROGRESS"] = "goalInProgress";
        status["MANUAL_OVERRIDE"] = "manualOverride";
        status["PENDING_REVIEW"] = "pendingReview";
    })(status = DeliverableSearchResultItem.status || (DeliverableSearchResultItem.status = {}));
    let videoState;
    (function (videoState) {
        videoState["NOT_UPLOADED"] = "not_uploaded";
        videoState["PENDING_REVIEW"] = "pending_review";
        videoState["PENDING_CREATOR"] = "pending_creator";
        videoState["APPROVED"] = "approved";
        videoState["IN_PROGRESS"] = "in_progress";
    })(videoState = DeliverableSearchResultItem.videoState || (DeliverableSearchResultItem.videoState = {}));
    let publicationStatus;
    (function (publicationStatus) {
        publicationStatus["UNLISTED"] = "unlisted";
        publicationStatus["PRIVATE"] = "private";
        publicationStatus["PUBLIC"] = "public";
        publicationStatus["UNKNOWN"] = "unknown";
    })(publicationStatus = DeliverableSearchResultItem.publicationStatus || (DeliverableSearchResultItem.publicationStatus = {}));
})(DeliverableSearchResultItem = exports.DeliverableSearchResultItem || (exports.DeliverableSearchResultItem = {}));
